import { auth } from '../firebase/config'
import mails from '../data/mails';
import { CiWarning } from 'react-icons/ci'
import Registration from '../components/Registration';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import Participants from '../components/Participants';
import ResultEntry from '../components/ResultEntry';
import NegativeMarks from '../components/NegativeMarks';
import { useState } from 'react';
import { useEffect } from 'react';


const AdminPanel = () => {

	const [house, setHouse] = useState("Aryans")

	const logout = () => {
		auth.signOut();
	}

	useEffect(() => {
		try {
			setHouse(mails[auth.currentUser.email].find(item => typeof item === "object").house);
		} catch(error) {
			console.log(error);
		}
	}, []);

	if (Object.keys(mails).includes(auth.currentUser.email)) {

		return (
			<div className="text-white mt-32 mb-10 mx-auto font-sans w-11/12 md:w-2/3 lg:w-3/5">
				<div>
					<h2 className="text-3xl font-bold font-hanoble">Admin Panel</h2>
				</div>

				<div className="flex justify-between mt-8 mb-12 py-4 px-6 border rounded-sm">
					<div className="flex flex-col justify-around">
						<h3>hello, <span className="font-semibold">{auth.currentUser.displayName}</span></h3>
						<button className="p-2 rounded-sm font-bold bg-amber-500 hover:bg-amber-600" onClick={logout}>SIGN OUT</button>
					</div>
					<img className="rounded-full" src={auth.currentUser.photoURL} alt="User" />
				</div>

				<div>
					<Tabs>

						<TabList>
							{mails[auth.currentUser.email].includes("registration") ? <Tab>Registration</Tab> : null}
							<Tab>Participants</Tab>
							{mails[auth.currentUser.email].includes("result entry") ? <Tab>Result Entry</Tab> : null}
							{mails[auth.currentUser.email].includes("result entry") ? <Tab>Negative Marks</Tab> : null}
						</TabList>

						{mails[auth.currentUser.email].includes("registration") ? <TabPanel><Registration house={house}/></TabPanel> : null}						
						<TabPanel><Participants /></TabPanel>
						{mails[auth.currentUser.email].includes("result entry") ? <TabPanel><ResultEntry /></TabPanel> : null}
						{mails[auth.currentUser.email].includes("result entry") ? <TabPanel><NegativeMarks /></TabPanel> : null}
						
					</Tabs>
				</div>

			</div>
		);
	} else {
		return (
			<div className="flex justify-center w-full font-hanoble">
				<div className="mt-40 mb-32 mx-6 text-justify">
					<h2>Hello, <span></span>{auth.currentUser.displayName}</h2>
					<CiWarning className="w-12 h-12 my-6" />
					<p>Sorry, it seems you are not found in the admin list. If this is a mistake, please contact the Bharatham committee</p>
					<button className="p-4 bg-blue-300" onClick={logout}>Sign out</button>
				</div>
			</div>
		)
	}

};

export default AdminPanel;
